import { brand } from '@/config/brand';
import styles from './SsoNotice.module.css';

/**
 * Info callout shown on the sign-up forms (business + individual): a plain tinted
 * box (not the @ui Alert, which carries an icon and different chrome) matching the
 * design's `--vn-info-*` note. Renders nothing when the brand has no SSO.
 */
export function SsoNotice() {
  if (!brand.features.sso) return null;
  return (
    <div className={styles.notice}>
      Your account will be created using <strong>{brand.ssoName}</strong> for unified
      access across all {brand.shortName} services with enhanced security features.
    </div>
  );
}

export default SsoNotice;
